import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { popBreadcrumbItem } from 'src/redux/Actions/Breadcrumb';

export default function Breadcrumb() {
  const { breadcrumbItems } = useSelector((state) => state.breadcrumbReducer);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleBreadcrumbClick = (pathname) => {
    dispatch(popBreadcrumbItem({ pathname }));
    navigate(pathname);
  };

  return (
    <div className="text-sm">
      {breadcrumbItems.map((breadcrumbItem, stackIndex) => {
        const breadcrumbLabels = breadcrumbItem.breadcrumbReducer || [
          breadcrumbItem.label,
        ];

        return breadcrumbLabels.map((label, labelIndex) => {
          const isLastLabel =
            stackIndex === breadcrumbItems.length - 1 &&
            labelIndex === breadcrumbLabels.length - 1;

          const isFirst = stackIndex === 0 && labelIndex === 0;

          return (
            <span key={`${breadcrumbItem.pathname}-${label}`}>
              {!isFirst && ' / '}
              {isLastLabel ? (
                <span className="text-blue">{label}</span>
              ) : (
                <button
                  onClick={() => handleBreadcrumbClick(breadcrumbItem.pathname)}
                  className="text-grey cursor-pointer breadcrumb-button"
                >
                  {label}
                </button>
              )}
            </span>
          );
        });
      })}
    </div>
  );
}
